export default "__VITE_ASSET__ncHrEAdN__"